import styled from 'styled-components';

import {
  BLACK,
  WHITE,
  BG_GRAY,
  STYLIST_LOCKUP,
  NAVIGATION_MOBILE_HEIGHT,
  NAVIGATION_DESKTOP_HEIGHT,
} from '../../../styles/variables.style';

import media from '../../../styles/media.style';

export const Wrapper = styled.div`
  background: ${BLACK};
  color: ${WHITE};
  flex-grow: 1;
  padding: 25px 16px;
  margin-top: ${NAVIGATION_MOBILE_HEIGHT}px;

  ${media.tabletP`
    padding: 25px 50px;
    margin-top: ${NAVIGATION_DESKTOP_HEIGHT}px;
  `};
`;

export const Inner = styled.div`
  width: 100%;
  margin: 0 auto;
  max-width: ${STYLIST_LOCKUP}px;
`;

export const AddTreatmentsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 30px;

  ${media.tabletP`
    margin-top: 80px;
  `};
`;

export const RowWrapper = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;

  ${media.tabletP`
    flex-direction: row;
  `};
`;

const Button = styled.button`
  position: relative;
  cursor: pointer;
  background-color: ${BG_GRAY.COMMON_8};
  color: ${WHITE};
  border: none;
  font-weight: 400;
  font-size: 14px;
  text-align: left;
  height: 60px;
  text-transform: uppercase;
  line-height: 60px;
  padding: 0 30px 0 67px;
`;

export const AddTreatmentsBtn = Button.extend`
  width: 100%;
`;

export const AddNoteBtn = Button.extend`
  flex: 1;
  margin-bottom: 10px;

  :disabled {
    opacity: 0.3;
  }

  ${media.tabletP`
    margin-bottom: 0;
  `};
`;

export const SaveDetailsBtn = Button.extend`
  flex: 1;
  font-weight: 800;
  text-align: center;
  padding: 0 30px;
  background-color: #4e4e4e;

  :disabled {
    opacity: 0.5;
  }

  ${media.tabletP`
    background-color: ${BG_GRAY.COMMON_8};
  `};
`;

export const Icon = styled.span`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 30px;
  display: inline-block;
  width: 25px;
  height: 25px;
  color: ${BLACK};
  background-color: ${WHITE};
  border-radius: 50%;
  vertical-align: middle;
  line-height: 40px;
  padding-left: 12px;

  ::after {
    content: '';
    width: 12px;
    height: 2px;
    background-color: ${BLACK};
    position: absolute;
    top: 51%;
    left: 51%;
    transform: translate(-50%, -50%);
  }

  ::before {
    content: '';
    width: 12px;
    height: 2px;
    background-color: ${BLACK};
    position: absolute;
    top: 51%;
    left: 51%;
    transition: transform 0.3s;
    transform: translate(-50%, -50%) rotate(${({ open }) => (open ? 0 : '90deg')});
  }
`;

export const AddTreatmentsBtnWrapper = styled.div`
  position: relative;
  flex: 1;
  margin-bottom: 10px;

  ${media.tabletP`
    margin-right: 10px;
    flex: 4;
  `};
`;

export const OptionsList = styled.div`
  position: absolute;
  top: 60px;
  left: 0;
  width: 100%;
  overflow: hidden;
  background-color: ${BG_GRAY.COMMON_8};
  max-height: ${({ open }) => (open ? '330px' : 0)};
  transition: max-height 0.3s;
  display: flex;
  flex-direction: column;
  z-index: 100;

  ul {
    padding: 20px 25px 0;
    margin: 0;
    list-style: none;
    display: flex;
    flex-wrap: wrap;
    :last-child {
      padding: 10px 25px 20px;

      ${media.tabletP`
        padding: 20px 40px 20px 25px;
      `};
    }

    ${media.tabletP`
      padding: 20px 25px 20px 40px;
    `};
  }

  li {
    width: 100%;

    :not(:last-child) {
      margin-bottom: 10px;
    }
  }

  ${media.tabletP`
    flex-direction: row;
    max-height: ${({ open }) => (open ? '240px' : 0)};
  `};
`;

export const TreatmentBtn = styled.button`
  cursor: pointer;
  font-size: 14px;
  text-transform: uppercase;
  background-color: transparent;
  border: none;
  padding: 0;
  margin: 0;
  text-align: left;
  color: ${WHITE};
  width: 100%;
  line-height: 40px;

  :disabled {
    opacity: 0.3;
  }
`;

export const TreatmentsList = styled.ul`
  list-style: none;
  width: 100%;
  margin: 0;
  padding: 0;
  margin-top: 60px;
`;

export const CurrentPage = styled.span`
  text-transform: uppercase;
  text-decoration: underline;
`;

export const Navigation = styled.div`
  font-size: 12px;
  font-weight: 500;
  letter-spacing: 0.1px;
  display: flex;
  line-height: 2.08;

  ${media.tabletP`
    justify-content: flex-end;
  `};
`;

export const NextPage = styled.span`
  text-transform: uppercase;
  margin-right: 20px;
`;

export const Spinner = styled.span`
  display: inline-block;
  width: 20px;
  height: 20px;

  ::after {
    content: ' ';
    display: block;
    width: 15px;
    height: 15px;
    margin: 1px;
    border-radius: 50%;
    border: 5px solid #fff;
    border-color: #fff transparent #fff transparent;
    animation: spinner 1.2s linear infinite;
  }

  @keyframes spinner {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;



// WEBPACK FOOTER //
// ./src/pages/StylistToolPages/NewVisitPage/NewVisitPage.style.js